import { styled } from "@mui/material/styles";
import {
    Avatar,
    ListItemAvatar,
    ListItemButton,
    Typography,
} from "@mui/material";
import { TEXT_ELLIPSIS } from "../../../Shared/styles";

export const AvatarListItemDefault = styled(Avatar)({
    backgroundColor: "var(--community-color-transparent-light-steal-blue-50)",
    width: "48px",
    height: "48px",
    svg: {
        width: "24px",
        height: "24px",
    },
});

export const ListItemAvatarContainer = styled(ListItemAvatar)({
    width: "48px",
    height: "48px",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    marginRight: "8px",
});

export const AvatarStyled = styled(Avatar)({
    width: "48px",
    height: "48px",
});

export const ListItemButtonContainer = styled(ListItemButton, {
    shouldForwardProp: (prop) => prop !== "showHover",
})<{ showHover?: boolean }>(({ showHover = true }) => ({
    alignItems: "center",
    padding: "8px 16px",
    "&:hover": {
        backgroundColor: showHover
            ? "var(--community-color-transparent-black-05)"
            : "transparent",
    },
}));

export const ListItemTextHeadline = styled(Typography)({
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--community-color-primary-text)",
    ...TEXT_ELLIPSIS,
});

export const ListItemTextSubline = styled(Typography)({
    fontSize: "14px",
    color: "var(--community-color-secondary-text)",
    ...TEXT_ELLIPSIS,
});
